import { createAction, createSlice } from '@reduxjs/toolkit';
import { transformDatapoint, computeFailureReasons } from '../../utils/analyticsTransform';

export const loadAnalyticsRequest = createAction('analytics/loadAnalyticsRequest');

const initialState = {
  dateRange: "30",
  dailyData: [],
  failureReasons: [],
  topTemplates: [],
  emailReport: {
    open: false,
    email: "",
    frequency: "daily"
  },
  loading: false,
  error: null,
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    setDateRange: (state, action) => {
      state.dateRange = action.payload;
    },
    toggleEmailReport: (state, action) => {
      state.emailReport.open = action.payload;
    },
    setReportEmail: (state, action) => {
      state.emailReport.email = action.payload;
    },
    setReportFrequency: (state, action) => {
      state.emailReport.frequency = action.payload;
    },
    fetchAnalyticsStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchAnalyticsSuccess: (state, action) => {
      try {
        const datapoints = action.payload?.data?.datapoints || [];
        state.dailyData = datapoints.map(transformDatapoint);
        state.loading = false;
        state.error = null;
      } catch (error) {
        state.error = 'Error processing analytics data';
        state.loading = false;
      }
    },

    fetchAnalyticsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload || 'Failed to fetch analytics';
      state.dailyData = [];
    },

    calculateFailureReasons: (state) => {
      state.failureReasons = computeFailureReasons(state.dailyData);
    },

    clearAnalytics: (state) => {
      state.dailyData = [];
      state.failureReasons = [];
      state.loading = false;
      state.error = null;
    },
  }
});

export const {
  setDateRange,
  toggleEmailReport,
  setReportEmail,
  setReportFrequency,
  fetchAnalyticsStart,
  fetchAnalyticsSuccess,
  fetchAnalyticsFailure,
  calculateFailureReasons,
  clearAnalytics,
} = analyticsSlice.actions;

export default analyticsSlice.reducer;
